<template>
  <v-snackbar
    top
    :value="showToast"
    :color="type"
    :timeout="-1"
    @input="hideToast"
  >
    <span v-html="message"></span>
    <v-icon @click="hideToast">close</v-icon>
  </v-snackbar>
</template>

<script>
  import { mapActions, mapState } from 'vuex';

  export default {
    name: 'TheToast',
    computed: {
      ...mapState('alert', ['showToast', 'type', 'message']),
    },
    methods: {
      ...mapActions('alert', ['hideToast']),
    },
  };
</script>

<style scoped>

</style>
